export default __webpack_public_path__ + "static/media/exam-overview-people-icon.c509ed2c.svg";